import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async () => {
    setBusy(true);
    try {
      const r = await api.post("/auth/forgot-password", { email });
      setResult(r.data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="page-forgot" className="mx-auto max-w-md px-4 py-16">
      <div className="border border-border p-8">
        <h1 className="font-display text-3xl">Forgot password</h1>
        {result ? (
          <div className="mt-6 space-y-4" data-testid="forgot-sent">
            <p className="text-muted-foreground text-sm">If an account exists for that email, a reset link has been sent.</p>
            {result.dev_reset_url && (
              <div className="border border-amber-300 dark:border-amber-800 bg-amber-50 dark:bg-amber-900/20 p-3 text-xs">
                <div className="font-semibold mb-1">Dev mode (Resend not configured):</div>
                <a href={result.dev_reset_url} className="underline break-all" data-testid="dev-reset-url">{result.dev_reset_url}</a>
              </div>
            )}
            <Button asChild variant="outline" className="rounded-none uppercase text-xs tracking-wider">
              <Link to="/login">Back to sign in</Link>
            </Button>
          </div>
        ) : (
          <div className="mt-6 space-y-4">
            <p className="text-muted-foreground text-sm">Enter your email — we'll send you a reset link.</p>
            <div>
              <Label className="font-overline">Email</Label>
              <Input type="email" className="rounded-none mt-2" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
            </div>
            <Button onClick={submit} disabled={busy || !email} className="w-full rounded-none uppercase tracking-wider h-11" data-testid="forgot-submit">
              {busy ? "…" : "Send Reset Link"}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
